export const formatDate = (date, hiddenTime, hiddenDate = false, showSeconds = false) => {
  const zero = (num) => (num < 10 ? 0 : '');

  const transformDate = new Date(date).toLocaleDateString().replace(/\//g, '.');
  const hours = new Date(date).getHours();
  const minutes = new Date(date).getMinutes();
  const seconds = new Date(date).getSeconds();

  const mainDateOutput = `${hiddenDate ? '' : transformDate}${hiddenTime ? '' : `${hiddenDate ? '' : ', '}`}`;
  let hmsOutput = '';
  if (!hiddenTime) {
    hmsOutput = `${hours}:${zero(minutes)}${minutes}`;
    if (showSeconds) hmsOutput += `:${zero(seconds)}${seconds}`;
  }

  return `${mainDateOutput}${hmsOutput}`;
};
